<template>
  <div class="home-container">
    <h1>🛍️ 商品管理</h1>
    <button @click="openNewCategory">➕ 添加分类</button>
    <div v-for="(category, index) in defaultCategory" :key="index" class="category-section">
      <h2>{{ category.text }} <button @click="openEditCategory(index)">编辑分类</button>
        <button @click="deleteCategory(index)">🗑️ 删除</button>
      </h2>
      <button @click="addProduct(category.id)">➕ 新增商品</button>

      <div v-if="category.data.length" class="product-list">
        <div v-for="(item, idx) in category.data" :key="idx" class="product-card">
          <img :src="item.src" loading="lazy" alt="商品图片" />
          <h3>{{ item.title }}</h3>
          <button @click="editProduct(index, idx)">编辑</button>

          <p>📦 发货方式：{{ item.sendWay }}</p>
          <p>🧮 库存：{{ item.count }} 🔥 已售：{{ item.sell }}</p>
          <p>排序：{{ item.sort }}</p>
          <p class="price">💰 ¥{{ item.price }}</p>
        </div>
      </div>
      <div v-else class="empty">暂无商品</div>
    </div>
  </div>

  <div v-if="showEditModal" class="modal-overlay">
    <div class="modal-content">
      <h3>📝 编辑商品</h3>
      <label>标题：
        <input v-model="editForm.title" />
      </label>
      <label>图片：
        <input type="file" @change="onImageSelect" />
      </label>
      <img v-if="editForm.src" :src="editForm.src" alt="预览" style="margin-top:10px; width:100px;" />

      <label>价格：
        <input v-model.number="editForm.price" type="number" />
      </label>
      <label>库存：
        <input v-model.number="editForm.count" type="number" />
      </label>
      <label>销量：
        <input v-model.number="editForm.sell" type="number" />
      </label>
      <label>排序：
        <input v-model.number="editForm.sort" type="number" />
      </label>
      <label>分类ID：
        <input v-model.number="editForm.cate_id" readonly="true" type="number" />
      </label>
      <div class="modal-actions">
        <button @click="saveProductEdit">保存</button>
        <button @click="cancelEdit">取消</button>
      </div>
    </div>
  </div>
  <div v-if="showCategoryModal" class="modal-overlay">
    <div class="modal-content">
      <h3>{{ isEditingCategory ? "🗂️ 编辑分类名称" : "🆕 添加分类" }}</h3>
      <input v-model="cateForm.editCategoryText" placeholder="请输入分类名称" />
      <input v-model="cateForm.sort" type="number" placeholder="请输入排序" />
      <label>
      是否显示：
      <select v-model="cateForm.isShow">
        <option :value="1">显示</option>
        <option :value="0">隐藏</option>
      </select>
    </label>
      <div class="modal-actions">
        <button @click="confirmCategoryEdit">保存</button>
        <button @click="cancelCategoryEdit">取消</button>
      </div>
    </div>
</div>


</template>



<script>

import { message } from 'ant-design-vue';

import { saveProduct,getAllCate,getProductList,deleteCate, uploadImage,saveCate} from '../util/api'; 

export default {
  name: 'IndexPage',
  data() {
    return {
    showCategoryModal: false,
    isEditingCategory: false,
    
    loadPath:"http://xiaotiankfbot.com:8070",
    cateForm:{
      id:0,
      isShow:1,
      editCategoryText: '',
      sort:0
    },  
    editingCategoryIndex: -1,
    showEditModal: false,
    editForm: {
      id:0,
      title: '',
      price: 0,
      count: 0,
      sell:0,
      cate_id:0,
      sort:0,
      src:"",
      mode:"0",
    },
    editingIndex: { category: -1, item: -1 },
      defaultCategory: [
             ]
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
     const cateList = await getAllCate();
     let defaultCategoryArr = [];
     const loadData = cateList.data;
     console.log(loadData)
     for(let i = 0;i < loadData.length;i++){
        let catagory = loadData[i];
        let productDate = []
        const product_list = await getProductList(catagory.id)
        if(product_list.data){
          productDate = product_list.data;
        }
        let defaultCate ={
          text:catagory.name,
          isShow:catagory.status,
          id:catagory.id,
          sort:catagory.sort,
          data:productDate
        }
       
        defaultCategoryArr.push(defaultCate);
      
     }

     console.log(defaultCategoryArr)
     this.defaultCategory = defaultCategoryArr
    },

 async editProduct(categoryIndex, itemIndex) {
    const item = this.defaultCategory[categoryIndex].data[itemIndex];
    this.editForm = { ...item };
    this.editingIndex = { category: categoryIndex, item: itemIndex };
    this.showEditModal = true;
  },
  saveProductEdit() {
    const {  item } = this.editingIndex;
    if (item === null) {
      //this.defaultCategory[category].data.push({ ...this.editForm });
      //这里添加商品
      this.editForm.mode = "0"
      saveProduct(this.editForm)

    } else {
     // this.$set(this.defaultCategory[category].data, item, { ...this.editForm });
      //这里是编辑商品
      this.editForm.mode = "1"
      saveProduct(this.editForm)
    }
    message.info("保存成功");
    this.showEditModal = false;

  },
  async onImageSelect(event) {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      alert('请上传 JPG / PNG / GIF / WebP 格式的图片');
      return;
    }

    const formData = new FormData();
    formData.append('image', file);

    const data = await uploadImage(file)

    console.log(data.filePath)
    this.editForm.src = this.loadPath+data.filePath;
    message.info("上传完成");

  },

  cancelEdit() {
    this.showEditModal = false;
  },
  openNewCategory() {
    this.editingCategoryIndex = -1;
    this.cateForm.editCategoryText = '';
    this.cateForm.isShow = 1; // 默认显示
    this.cateForm.sort = 0; // 默认显示

    this.isEditingCategory = false;
    this.showCategoryModal = true;
  },

  openEditCategory(index) {
    const category = this.defaultCategory[index];
    this.editingCategoryIndex = index;
    this.cateForm.editCategoryText = category.text;
    this.cateForm.isShow = category.isShow ?? 1; // 兼容老数据
    this.cateForm.sort = category.sort; // 默认显示
    this.cateForm.id = category.id;
    this.isEditingCategory = true;
    this.showCategoryModal = true;
  },
 async confirmCategoryEdit() {
    const newText = this.cateForm.editCategoryText.trim();
  if (!newText) return;

  if (this.editingCategoryIndex === -1) {
    // 新增
    const newId = Date.now(); // 你也可以用后端 ID
    this.defaultCategory.push({
      text: newText,
      id: newId,
      isShow: this.cateForm.isShow,
      data: []
    });
    let data = {
      id:null,
      name:this.cateForm.editCategoryText,
      sort:this.cateForm.sort,
      isshow:this.cateForm.isShow+""
    }

    await saveCate(data)
    message.success("分类添加成功");
  } else {
    // 编辑
    const category = this.defaultCategory[this.editingCategoryIndex];
    category.text = newText;
    category.isShow = this.cateForm.isShow;
    category.sort = this.cateForm.sort;
    let data = {
      id:category.id,
      name:this.cateForm.editCategoryText,
      sort:this.cateForm.sort,
      isshow:this.cateForm.isShow+""
    }

    await saveCate(data)
    message.success("分类更新成功");
  }

  this.showCategoryModal = false;
  },

  async deleteCategory(index) {
    const confirmDelete = confirm(`确定要删除分类 "${this.defaultCategory[index].text}" 吗？`);
    if (confirmDelete) {
      let id = this.defaultCategory[index].id;
      
      await deleteCate(id)
      message.success("分类已删除");
      this.defaultCategory.splice(index, 1);
    }
  },
  cancelCategoryEdit() {
    this.showCategoryModal = false;
  },
  addProduct(categoryIndex) {
    this.editForm = {
      title: '',
      price: 0,
      count: 0,
      src: '',
      sort:0,
      cate_id:categoryIndex,
      sendWay: '自动发货',
      sell: 0
    };
    this.editingIndex = { category: categoryIndex, item: null };
    this.showEditModal = true;
  },



}
}
</script>

<style scoped>
.home-container {
  max-width: 1080px;
  margin: auto;
  padding: 30px;
}
.category-section {
  margin-bottom: 40px;
}
.product-list {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}
.product-card {
  border: 1px solid #ddd;
  padding: 16px;
  border-radius: 6px;
  background-color: #fff;
  text-align: center;
}
.product-card img {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 10px;
}
.price {
  font-weight: bold;
  color: #e91e63;
}
.empty {
  color: #888;
  padding-left: 12px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content {
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 300px;
}
.modal-content label {
  display: block;
  margin-bottom: 12px;
}
.modal-actions {
  display: flex;
  justify-content: space-between;
}
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
.modal-content {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  width: 300px;
}
.modal-content h3 {
  margin-top: 0;
}
.modal-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.modal-content input {
  width: 100%;
  padding: 8px;
  margin-top: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.edit-btn {
  margin-left: 10px;
  font-size: 12px;
}


</style>
